var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 71 369.78 369.78",
    width: 369.78,
    height: 369.78,
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.25 0 0 -1.25 0 45)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#009543"
    },
    d: "M409.6-271.2c0-25.134-20.378-45.511-45.511-45.511H45.511C20.378-316.711,0-296.334,0-271.2 v204.8c0,25.134,20.378,45.511,45.511,45.511h318.578c25.134,0,45.511-20.378,45.511-45.511V-271.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ED4135"
    },
    d: "M409.6-225.689H0v113.778h409.6V-225.689z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0035AD"
    },
    d: "M364.089-20.889H45.511C20.378-20.889,0-41.266,0-66.4v-45.511h409.6V-66.4 C409.6-41.266,389.222-20.889,364.089-20.889"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M254.885-168.8c0-59.073-47.889-106.974-106.974-106.974S40.926-227.873,40.926-168.8 c0,59.085,47.9,106.974,106.985,106.974S254.885-109.715,254.885-168.8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAE600"
    },
    d: "M250.311-168.8c0-56.559-45.841-102.4-102.4-102.4s-102.4,45.841-102.4,102.4 s45.841,102.4,102.4,102.4S250.311-112.241,250.311-168.8"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M150.096-271.109h-3.664v204.618h3.664V-271.109L150.096-271.109z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M162.133-131.47c0-7.657-6.212-13.87-13.87-13.87s-13.87,6.212-13.87,13.87 s6.212,13.87,13.87,13.87S162.133-123.812,162.133-131.47"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M159.63-217.338c0-8.943-5.097-16.179-11.378-16.179s-11.378,7.236-11.378,16.179 s5.097,16.179,11.378,16.179S159.63-208.395,159.63-217.338"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M162.133-171.997c0-4.619-6.212-8.351-13.87-8.351s-13.87,3.732-13.87,8.351 s6.212,8.351,13.87,8.351S162.133-167.378,162.133-171.997"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M132.983-111.911c0,0-1.422,9.956,1.422,14.222c2.844,4.267,10.308,8.181,16.35,9.603 c6.053,1.422,14.234,10.308,14.234,10.308s-1.07-13.153-11.025-21.333C144.009-107.292,132.983-111.911,132.983-111.911"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M124.268-132.164c0,0,5.507-3.55,6.929-8.886c1.422-5.336,5.336-11.025,16.714-11.025v-6.406 c0,0-9.603-0.705-14.928,1.422c-5.336,2.139-6.758,12.095-6.758,15.656C126.225-137.852,124.268-132.164,124.268-132.164"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M171.918-132.164c0,0-5.507-3.55-6.929-8.886c-1.422-5.336-5.336-11.025-16.714-11.025v-6.406 c0,0,9.603-0.705,14.928,1.422c5.336,2.139,6.758,12.095,6.758,15.656C169.961-137.852,171.918-132.164,171.918-132.164"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M169.961-205.061c0,3.55-1.604,13.505-6.929,15.644c-5.336,2.128-15.11,2.958-15.11,2.958 s-9.603-0.831-14.939-2.958c-5.336-2.139-6.758-12.095-6.758-15.644s-1.957-20.617-1.957-20.617s7.475,12.481,8.897,17.818 s7.282,11.981,14.757,11.981c7.634,0,13.687-6.406,15.11-11.742c1.422-5.325,8.795-18.057,8.795-18.057 S169.961-208.611,169.961-205.061"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13 12)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M134.911-249.067V-283.2c0,0-9.956-1.07-24.178,2.662c-14.222,3.732-16.885,5.154-16.885,5.154 s14.473,14.495,20.799,19.923C122.111-249.067,134.911-249.067,134.911-249.067"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M134.911-249.067V-283.2c0,0,9.956-1.07,24.178,2.662c14.222,3.732,16.885,5.154,16.885,5.154 s-14.473,14.495-20.799,19.923C147.711-249.067,134.911-249.067,134.911-249.067"
  })))))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNc);
export default __webpack_public_path__ + "static/media/nc.fc4f52c99179870898b92da8e67e35fa.svg";
export { ForwardRef as ReactComponent };